import { IconProps } from "./types";

const DEFAULT_SIZE = 80;

export const Exclamation = ({ style, size = DEFAULT_SIZE }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <rect width="80" height="80" rx="40" fill="#7B1C1C" />
      <path
        d="M38.021 43.271V27.521H41.521V43.271H38.021ZM38.021 52.021V48.521H41.521V52.021H38.021Z"
        fill="white"
      />
    </svg>
  );
};
